// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hCYmT","select":"styles_select__1tM67"};